import { Injectable } from '@angular/core';

@Injectable()
export class CacheStorageService {

  // Time cache data. Default 5 minutes.
  timeCache: number = 5 * 60 * 1000;

  private __storage = {};
  private __queue = {};

  constructor() { }

  promiseQueue(name: string, promise: Function, resovle: Function) {
    if (this.__queue[name]) {
      this.__queue[name].push(resovle);
    } else {
      this.__queue[name] = [resovle];
      promise(name);
    }
  }

  resolveQueue(name: string, context: any, args?: any[]) {
    if (this.__queue[name]) {
      this.__queue[name].forEach(fn => {
        try {
          fn.apply(context, args);
        } catch (e) {

        }
      });
      delete this.__queue[name];
    }
  }

  getData(key: string) {
    const data: CacheStorageItem = this.__storage[key];
    // Check data expired
    if (data && new Date().getTime() - data.time <= data.timeCache) {
      return data.value;
    }
  }

  setData(key: string, data: any, options?: CacheStorageOptions) {
    const timeCache = options && options.timeCache || this.timeCache;
    this.__storage[key] = <CacheStorageItem>{
      time: new Date().getTime(),
      timeCache: timeCache,
      value: data
    };
  }

  removeData(key: string) {
    delete this.__storage[key];
  }

  clearData() {
    this.__storage = {};
  }

}

export interface CacheStorageOptions {
  timeCache?: number;
  resolveData?: boolean;
}

export interface CacheStorageItem {
  time: number;
  timeCache: number;
  value: any;
}
